<!--
 * @Author: 赵健
 * @Date: 2021-01-19 09:46:54
 * @LastEditTime: 2021-01-28 14:21:54
 * @LastEditors: 赵健
 * @Description: 修改描述
 * @FilePath: \trunk\src\views\merchantCenter\merchantManage\edit.vue
-->
<template>
  <div>
    <um-bread-crumb />
    <el-form
      ref="baseInfo"
      :model="baseInfo"
      label-width="120px"
    >
      <el-card
        v-loading="loading"
        shadow="never"
      >
        <div
          slot="header"
          class="card-header"
        >
          <span>商家信息</span>
        </div>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              ref="merchantName"
              label="商家名称:"
              prop="merchantName"
              :rules="[
                {required: true, message: '必填项不能为空', trigger: 'blur' },
                {max:30,min:1, message: '长度在1到30个字符', trigger: 'change' },
              ]"
            >
              <el-input
                v-model="baseInfo.merchantName"
                style="width:100%"
                placeholder="请输入商家名称"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              ref="merchantCompany"
              label="所属公司:"
              prop="merchantCompany"
              :rules="[
                {max:30,min:1, message: '长度在1到30个字符', trigger: 'change' },
              ]"
            >
              <el-input
                v-model="baseInfo.merchantCompany"
                style="width:100%"
                placeholder="请输入所属公司"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              ref="merchantContactPerson"
              label="联系人:"
              prop="merchantContactPerson"
              :rules="[
                {max:10,min:1, message: '长度在1到10个字符', trigger: 'change' },
              ]"
            >
              <el-input
                v-model="baseInfo.merchantContactPerson"
                style="width:100%"
                placeholder="请输入联系人"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              ref="merchantContactDetails"
              label="联系方式:"
              prop="merchantContactDetails"
              :rules="[
                {max:30,min:1, message: '长度在1到30个字符', trigger: 'change' },
              ]"
            >
              <el-input
                v-model="baseInfo.merchantContactDetails"
                style="width:100%"
                placeholder="请输入联系方式"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item
              ref="merchantAddress"
              label="地址:"
              prop="merchantAddress"
            >
              <el-button
                type="primary"
                @click="mapVisible=true"
              >从地图上选</el-button>
              <el-input
                v-model="baseInfo.merchantAddress"
                class="margin-t-10"
                style="width:100%"
                placeholder="请输入详细地址"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item
              ref="merchantDescription"
              label="商家描述:"
              prop="merchantDescription"
              :rules="[
                {max:200,min:1, message: '长度在1到200个字符', trigger: 'change' },
              ]"
            >
              <el-input
                v-model="baseInfo.merchantDescription"
                placeholder="请输入商家描述"
                maxlength="200"
                type="textarea"
                :rows="3"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item
              ref="merchantDesignNoList"
              label="商家照片:"
              prop="merchantDesignNoList"
              :rules="[
                {required: true, message: '必填项不能为空', trigger: 'blur' },
              ]"
            >
              <um-upload-img
                v-model="baseInfo.merchantDesignNoList"
                style="width: 100%;"
                :limit="5"
                :is-cropper="true"
                :simple="true"
                :cropper-options="{
                  aspectRatio: 16 / 9
                }"
                placeholder="建议尺寸16:9"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item
              ref="merchantLogoList"
              label="商家logo:"
              prop="merchantLogoList"
            >
              <um-upload-img
                v-model="baseInfo.merchantLogoList"
                style="width: 100%;"
                :limit="1"
                :is-cropper="true"
                :simple="true"
                :cropper-options="{
                  aspectRatio: 40 / 9
                }"
                placeholder="建议尺寸40:9"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item
              ref="merchantSmallLogoList"
              label="小logo:"
              prop="merchantSmallLogoList"
            >
              <um-upload-img
                v-model="baseInfo.merchantSmallLogoList"
                style="width: 100%;"
                :limit="1"
                :is-cropper="true"
                :simple="true"
                :cropper-options="{
                  aspectRatio: 1 / 1
                }"
                placeholder="建议尺寸1:1"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item
              ref="merchantBusinessLicenseUrlList"
              label="营业执照:"
              prop="merchantBusinessLicenseUrlList"
            >
              <um-upload-img
                v-model="baseInfo.merchantBusinessLicenseUrlList"
                style="width: 100%;"
                :limit="5"
                :simple="true"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <el-button
          type="primary"
          style="margin: 0 auto;display: block;"
          @click="submitForm"
        >确定</el-button>
      </el-card>
    </el-form>
    <el-dialog
      title="选择地址"
      :visible.sync="mapVisible"
      width="840px"
      destroy-on-close
      :append-to-body="true"
    >
      <um-map
        v-model="activityLatLngBaidu"
        :readonly="false"
      />
      <div
        slot="footer"
        class="dialog-footer text-center"
      >
        <el-button
          type="primary"
          @click="mapSubmit"
        >保 存</el-button>
        <el-button @click="mapVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { merchantDetails, merchantEdit } from '@/api/merchantCenter.js'
import { reverseGeocoding, transformBD } from '@/utils'
export default {
  name: 'MerchantMerchantManageEdit',
  data() {
    return {
      loading: false,
      baseInfo: {
        merchantName: '',
        merchantCompany: '',
        merchantContactPerson: '',
        merchantContactDetails: '',
        merchantAddress: '',
        longitude: '',
        latitude: '',
        marsLongitude: '',
        marsLatitude: '',
        merchantDescription: '',
        merchantDesignNoList: [],
        merchantLogoList: [],
        merchantSmallLogoList: [],
        merchantBusinessLicenseUrlList: []
      },
      mapVisible: false,
      activityLatLngBaidu: {}
    }
  },
  created() {
    this.getMerchantDetails()
  },
  methods: {
    async getMerchantDetails() {
      try {
        this.loading = true
        const res = await merchantDetails()
        this.activityLatLngBaidu.lng = res.data.data.longitude || ''
        this.activityLatLngBaidu.lat = res.data.data.latitude || ''
        this.baseInfo.merchantName = res.data.data.merchantName
        this.baseInfo.merchantCompany = res.data.data.merchantCompany
        this.baseInfo.merchantContactPerson =
          res.data.data.merchantContactPerson
        this.baseInfo.merchantContactDetails =
          res.data.data.merchantContactDetails
        this.baseInfo.merchantAddress = res.data.data.merchantAddress
        this.baseInfo.longitude = res.data.data.longitude
        this.baseInfo.latitude = res.data.data.latitude
        this.baseInfo.marsLongitude = res.data.data.marsLongitude
        this.baseInfo.marsLatitude = res.data.data.marsLatitude
        this.baseInfo.merchantDescription = res.data.data.merchantDescription
        this.baseInfo.merchantDesignNoList = res.data.data.merchantDesignNoList || []
        this.baseInfo.merchantLogoList =
          res.data.data.merchantLogoList || []
        this.baseInfo.merchantSmallLogoList =
          res.data.data.merchantSmallLogoList || []
        this.baseInfo.merchantBusinessLicenseUrlList =
          res.data.data.merchantBusinessLicenseUrlList || []
        this.loading = false
      } catch (e) {
        this.loading = false
        this.errorHandle(e)
      }
    },
    async mapSubmit() {
      const latlng = this.activityLatLngBaidu
      if (!latlng.lat || !latlng.lng) {
        this.$message.info('请选择位置！')
        return false
      }
      try {
        const d2 = await reverseGeocoding(latlng.lng, latlng.lat)
        this.baseInfo.merchantAddress = d2.result.formatted_address
      } catch (e) {
        this.$message.error('获取位置失败！')
        this.baseInfo.merchantAddress = '定位失败'
        return false
      }
      try {
        // lng x 经度
        const d = await transformBD(latlng.lng, latlng.lat, 'gcj02')
        if (d.result && d.result[0]) {
          this.baseInfo.marsLongitude = d.result[0].x
          this.baseInfo.marsLatitude = d.result[0].y
          this.baseInfo.longitude = latlng.lng
          this.baseInfo.latitude = latlng.lat
        } else {
          this.baseInfo.marsLongitude = this.baseInfo.marsLatitude = ''
          this.$message.error('获取经纬度失败！')
        }
      } catch (e) {
        this.baseInfo.marsLongitude = this.baseInfo.marsLatitude = ''
        this.$message.error('获取经纬度失败！')
        return false
      }
      this.mapVisible = false
    },
    submitForm() {
      this.$refs.baseInfo.validate(async valid => {
        if (valid) {
          try {
            this.loading = true
            if (!Array.isArray(this.baseInfo.merchantSmallLogoList)) {
              this.baseInfo.merchantSmallLogoList = [this.baseInfo.merchantSmallLogoList]
            }
            if (!Array.isArray(this.baseInfo.merchantLogoList)) {
              this.baseInfo.merchantLogoList = [this.baseInfo.merchantLogoList]
            }
            await merchantEdit(this.baseInfo)
            this.$message.success('操作成功!')
            this.loading = false
            this.$router.go(-1)
          } catch (e) {
            this.loading = false
            this.errorHandle(e)
          }
        } else {
          this.$message.warning('请输入正确的表单！')
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
